import { Alert, AlertTitle, Box, Link, Typography } from 'ui/mui';
import { useLocation } from 'react-router-dom';
import { fetchInfoMessages } from './data';
import { userIsNonCustomer } from '@/helpers/customerUtils';
import { useSelector } from 'react-redux';
import { State } from '@/types/State';
import ScheduledContent from 'ui/components/ScheduledContent';
import { useQuery } from '@tanstack/react-query';

export const InfoMessage = () => {
  const location = useLocation();
  const selectedCustomer = useSelector(
    (state: State) => state.user.selectedCustomer,
  );

  const { data } = useQuery({
    queryKey: ['infoMessages', selectedCustomer?.customerId],
    queryFn: () => fetchInfoMessages(selectedCustomer?.customerId),
    enabled:
      !!selectedCustomer?.customerId && !userIsNonCustomer(selectedCustomer),
    staleTime: 60 * 1000,
  });

  const messages = data?.alerts || [];

  const filteredMessages = messages?.filter(
    (message) => message?.displayLocation === location.pathname,
  );

  if (filteredMessages.length === 0) return null;

  return (
    <>
      {filteredMessages.map((message, index) => {
        const alertContent = (
          <Alert key={index} severity={message.type} sx={{ mb: 4 }}>
            <Box>
              <AlertTitle>{message.title}</AlertTitle>
              <Typography variant='body2'>{message.content}</Typography>
              {message.link && (
                <Link
                  href={message.link.url}
                  sx={{ display: 'inline-block', mt: 1 }}
                >
                  {message.link.text}
                </Link>
              )}
            </Box>
          </Alert>
        );
        if (message.startDate && message.endDate) {
          return (
            <ScheduledContent
              key={index}
              dateRanges={[
                {
                  from: new Date(message.startDate),
                  to: new Date(message.endDate),
                },
              ]}
            >
              {alertContent}
            </ScheduledContent>
          );
        }

        return alertContent;
      })}
    </>
  );
};
